module.exports = __webpack_public_path__ + "static/img/dengbao.73d837e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dengbao.jpg
// module id = L+I8
// module chunks = 0